module.exports = __webpack_public_path__ + "img/hovered-layer2.02b49e0e.png";